<template>
    <div>
        <!-- <van-tabs v-model="activeName" sticky  animated  @click="onClick">
            <template v-for="TemplateEle in list">
                <van-tab v-for="ele in TemplateEle.children" :key="ele.id" :title="ele.name" :name="ele.id"> -->
                  <div class="classmargintop">
                    <ul class="posiart">
                      <li @click="LiBorder(0)" style="display:flex;justify-content:center;align-items: center ; height:98%;"><p style="height:100%; display: flex;justify-content: center;align-items: center;flex-direction: column;" :class="index==0?'BorderCenter FontLi':'FontLi'">综 合</p></li>
                      <li @click="LiBorder(1)" style="display:flex;justify-content:center;align-items: center ; height:98%;"><p style="height:100%; display: flex;justify-content: center;align-items: center;flex-direction: column;" :class="index==1?'BorderCenter FontLi':'FontLi'">销 量</p></li>
                      <li @click="LiBorder(2)" style="display:flex;justify-content:center;align-items: center ; height:98%;"><p style="height:100%; display: flex;justify-content: center;align-items: center;" :class="statusway?'BorderCenter FontLi':'FontLi'">价 格<span style="display: flex;justify-content: center;align-items: center;flex-direction: column;padding-left:5px;">
                        <img class="imgWidth" v-if="index==2" style="margin-bottom:-2px;" src="@/assets/redtriangle.png" alt="">
                        <img class="imgWidth" v-else style="margin-bottom:-2px;" src="@/assets/triangle.png" alt="">
                        <img class="imgWidth" v-if="index==3" style="margin-bottom:-2px;" src="@/assets/LowerRed.png" alt="">
                        <img class="imgWidth" v-else src="@/assets/Lower.png" alt="">
                        </span>
                        </p></li>
                    </ul>
                    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="marginTopRefrsh"> <!-- 下拉刷新 -->
                      <van-list v-model="loading" :finished="finished" loading-text="正在加载中..." :error.sync="error" error-text="请求失败，点击重新加载" finished-text="我是有底线的哦 ~ " @load="onLoad" :immediate-check="false"><!-- 上拉加载 -->
                        <div class="comntmarginTop" style="display: flex; justify-content: flex-start; flex-wrap:wrap; align-items:stretch;">
                          <div v-for="(ele,index) in dataList" :key="index" @click="goHome(ele)">
                            <dl class="comntDl" v-if="ele.houniaoAbroadStatus!==1">
                              <dt>
                                <van-image :src="ele.pic">
                                  <template v-slot:error>加载失败</template>
                                </van-image>
                              </dt>
                              <dd>
                                <p class="ellpis">
                                  <span v-if="ele.supplierCode=='ZY'" class="ZY">自营</span>
                                  <span v-else-if="ele.houniaoAbroadStatus ===1" class="houniaoAbroadStatus">海外</span>
                                  <span v-if="ele.supplierCode=='ZY'" :class="ele.supplierCode=='ZY'?'Name ':''">{{ele.name}}</span>
                                  <span v-else-if="ele.houniaoAbroadStatus ===1" :class="ele.houniaoAbroadStatus==1?'Name ':''">{{ele.name}}</span>
                                  <span v-else >{{ele.name}}</span>
                                </p>
                                <p>
                                  <span class="EleName">￥{{ele.price}}</span><s class="EleOriginalPrice">￥{{ele.originalPrice}}</s>
                                </p>
                              </dd>
                            </dl>
                          </div>
                        </div>
                      </van-list>
                    </van-pull-refresh>
                  </div>
                <!-- </van-tab>
            </template>
        </van-tabs> -->
    </div>
</template>
<script>
import { Tab, Tabs, List, PullRefresh, Image } from 'vant'
import { productList, Categorization } from '../../request/api.js'
var indexs = 2
export default {
  components: {
    [Image.name]: Image,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data () {
    return {
      // activeName: 'a',
      list: [],
      error: false,
      dataList: [], // 请求数据
      loading: false, // 上拉加载
      finished: false, // 上拉加载完毕
      isLoading: false, // 下拉刷新
      pageNum: 1, // 页码
      index: 0,
      statusway: false,
      order: 1,
      setscroll: false
    }
  },
  // 检测页面滚动
  // mounted() {
  //   window.addEventListener('scroll', this.scrollToTop)
  //   scrollToTop() {
  //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
  //     console.log(scrollTop)
  //     if (scrollTop >= 100) {
  //       this.setscroll = true
  //     } else {
  //       this.setscroll = false
  //     }
  //   },
  // },
  methods: {
    // 具体商品
    productListCode () {
      const params = {
        order: 1,
        pageSize: 12,
        pageNum: this.pageNum
      }
      if (this.$route.query.tabStatus !== undefined) {
        params.tabStatus = this.$route.query.tabStatus
      }
      if (this.$route.query.activityId !== undefined) {
        params.activityId = this.$route.query.activityId
      }
      if (this.$route.query.Roll !== undefined) {
        params.productCategoryId = this.$route.query.Roll
      }
      console.log(params)
      productList(params).then(res => {
        console.log(res, 'res')
        this.dataList = res.data.list
      }).catch(res => {
        console.log(res)
      })
    },
    // title头设置
    productCategoryTwoThree () {
      const params = {
        product_category_id: this.$route.query.ID
      }
      Categorization(params).then(res => {
        console.log(res)
        this.list = res.data[0].children
        console.log(this.list)
      }).catch(res => {
        console.log(res)
      })
    },
    onLoad () {
      this.pageNum += 1
      const params = {
        order: this.order,
        pageSize: 12,
        pageNum: this.pageNum
      }
      if (this.$route.query.tabStatus !== undefined) {
        params.tabStatus = this.$route.query.tabStatus
      }
      if (this.$route.query.activityId !== undefined) {
        params.activityId = this.$route.query.activityId
      }
      if (this.$route.query.Roll !== undefined) {
        params.productCategoryId = this.$route.query.Roll
      }
      console.log(params)
      productList(params).then(res => {
        console.log(res)
        if (res.code === 200) {
          setTimeout(() => {
            this.dataList = this.dataList.concat(res.data.list)
            this.loading = false
            if (this.dataList.length >= res.data.total) {
              this.finished = true
            }
          }, 1000)
        } else {
          this.error = true
        }
      }).catch(res => {
        console.log(res)
      })
    },
    onRefresh () {
      setTimeout(() => {
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.isLoading = false
        this.onLoad()
      }, 1000)
    },
    LiBorder (i) {
      if (i === 2) {
        this.statusway = true
        if (indexs === 2) {
          this.index = i
          indexs = 3
        } else {
          this.index = 3
          this.statusway = true
          indexs = 2
        }
      } else {
        this.statusway = false
        this.index = i
      }
      if (this.index === 0) {
        this.pageNum = 1
        this.order = 1
        const params = {
          order: this.order,
          pageSize: 12,
          pageNum: this.pageNum
        }
        if (this.$route.query.tabStatus !== undefined) {
          params.tabStatus = this.$route.query.tabStatus
        }
        if (this.$route.query.activityId !== undefined) {
          params.activityId = this.$route.query.activityId
        }
        if (this.$route.query.Roll !== undefined) {
          params.productCategoryId = this.$route.query.Roll
        }
        console.log(params)
        productList(params).then(res => {
          console.log(res)
          this.dataList = res.data.list
        }).catch(res => {
        // console.log(res)
        })
      } else if (this.index === 1) {
        this.pageNum = 1
        this.order = 2
        const params = {
          order: this.order,
          pageSize: 12,
          pageNum: this.pageNum
        }
        if (this.$route.query.tabStatus !== undefined) {
          params.tabStatus = this.$route.query.tabStatus
        }
        if (this.$route.query.activityId !== undefined) {
          params.activityId = this.$route.query.activityId
        }
        if (this.$route.query.Roll !== undefined) {
          params.productCategoryId = this.$route.query.Roll
        }
        console.log(params)
        productList(params).then(res => {
          console.log(res)
          this.dataList = res.data.list
        }).catch(error => {
          console.log(error)
        })
      } else if (this.index === 2) {
        this.pageNum = 1
        this.order = 4
        const params = {
          order: this.order,
          pageSize: 12,
          pageNum: this.pageNum
        }
        if (this.$route.query.tabStatus !== undefined) {
          params.tabStatus = this.$route.query.tabStatus
        }
        if (this.$route.query.activityId !== undefined) {
          params.activityId = this.$route.query.activityId
        }
        if (this.$route.query.Roll !== undefined) {
          params.productCategoryId = this.$route.query.Roll
        }
        console.log(params)
        productList(params).then(res => {
          console.log(res)
          this.dataList = res.data.list
        }).catch(res => {
        // console.log(res)
        })
        sessionStorage.setItem('xlpx', 1)
      } else if (this.index === 3) {
        this.pageNum = 1
        this.order = 5
        const params = {
          order: this.order,
          pageSize: 12,
          pageNum: this.pageNum
        }
        if (this.$route.query.tabStatus !== undefined) {
          params.tabStatus = this.$route.query.tabStatus
        }
        if (this.$route.query.activityId !== undefined) {
          params.activityId = this.$route.query.activityId
        }
        if (this.$route.query.Roll !== undefined) {
          params.productCategoryId = this.$route.query.Roll
        }
        console.log(params)
        productList(params).then(res => {
          console.log(res)
          this.dataList = res.data.list
        }).catch(res => {
        // console.log(res)
        })
        sessionStorage.setItem('xlpx', 2)
      }
    },
    goHome (ele) {
      this.$router.push({ path: '/CommodityDetails', query: { id: ele.id, skuId: ele.defaultSkuId } })
      // this.$router.push(`/CommodityDetails/${ele.id}`)
    },
    onClick (name, title) {
      // console.log(name, title)
      // 具体商品
      const params = {
        productCategoryId: name,
        order: 1,
        pageSize: 12,
        pageNum: this.pageNum
      }
      console.log(params)
      productList(params).then(res => {
        console.log(res)
        this.dataList = res.data.list
      }).catch(res => {
        // console.log(res)
      })
    }
  },
  activated() {
    if (!this.$route.meta.isBack || this.isFirstEnter) {
      // console.log('activated')

      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
      // this.activeName = this.$route.query.Roll
      this.index = 0
      indexs = 2
      this.LiBorder(0)
      this.list = [] // 把数据清空，可以稍微避免让用户看到之前缓存的数据
      this.dataList = []
      this.productListCode()
      // this.productCategoryTwoThree()
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false
    // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    this.isFirstEnter = false
  },
  created () {
    this.isFirstEnter = true
    // console.log('created')
    // this.activeName = this.$route.query.Roll
    // this.productListCode()
    // this.productCategoryTwoThree()
    // console.log(this.$route.query)
    // document.title = this.$route.query.name
    // localStorage.setItem('titleName', this.$route.query.name)
  },
  beforeRouteEnter(to, from, next) {
    // console.log(to, from)
    if (from.name === 'CommodityDetails') {
      to.meta.isBack = true
    }
    next()
  }
}
</script>
<style lang="less" scoped>
    /deep/ .van-sticky {
        height: 90px;
    }
    /deep/ .van-tabs--line .van-tabs__wrap {
      height: 90px;
      border: 0.2px solid #F2F2F2; /*no*/
      border-bottom: 1px solid #F2F2F2; /*no*/
    }
    /deep/ .van-tab {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    // /deep/ .van-tabs__track {
    //   transform: none !important;
    // }
    .Name {
      padding-left: 12px;
    }
    .EleName {
      color: #333333;
      font-size: 32px;
      font-weight:bold;
      padding-right: 15px;
    }
    .EleOriginalPrice {
      color: #999999;
      font-size: 28px;
    }
    .comntmarginTop {
      padding-left: 30px;
    }
    .comntmarginTop dl:nth-child(odd){ //所有奇数
      margin-right: 18px;
    }
    .comntDl {
      width:336px;
      border-radius:4px 4px 0px 0px;
      margin-bottom: 25px;
    dt{
      width: 100%;
      height:336px;
      .van-image{
        width: 100%;
        height: 100%;
      }
    }
    dd{
      height: 120px;
      font-size:28px;
      color:rgba(51,51,51,1);
    }
  }
  .ZY{
    color: white;
    padding:2px 12px;
    font-size: 24px;
    border-radius: 5px;
    background-color: #E33F36;
  }
  //多行文本溢出隐藏
  .ellpis{
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .houniaoAbroadStatus {
    color: #E33F36;
    padding:1px 12px;
    font-size: 24px;
    border-radius: 5px;
    border: 1px solid #E33F36;/*no*/
  }
  /deep/.van-tabs__line{
    background-color: #E33F36;
    width: 60px;
  }
  .posiart{
    margin-bottom:10px;
    position:fixed;
    left:0;
    top:0px;
    width:100%;
    z-index:2;
    background-color: #FCFCFC;
    height: 80px;
    display:flex;
    justify-content:flex-start;
    align-items: center ;
    text-align: center;
    border-bottom: 0.2px solid #ccc;/*no*/
    li{
      width: 33%;
    }
  }
  .marginTopRefrsh{
    margin-top: 100px;
  }
  .BorderCenter {
    border-bottom: 1px #B4272D solid;/*no*/
    font-weight: 800;
  }
  .FontLi {
    font-size: 28px;
  }
  .imgWidth {
    width:18px;
    height:18px;
  }
</style>
